<template>
  <div class="text-center">
    <div>
      <a
        class="legacy-dashboard"
        :href="`${root}/admin/promoterDashboard`"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t("top-menu.all.legacy-dashboard") }}
      </a>
      <div class="styleMenuv" v-for="(item, i) in items" :key="`racebtn-${i}`">
        <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="item.name" small link class="ma-2" @click="changeComponent(item.name)" v-bind="attrs" v-on="on">
            <i :class="item.icon"></i>
            {{ item.text }}
          </v-btn>
          <v-btn v-else small link class="ma-2" v-bind="attrs" v-on="on">
            <i :class="item.icon"></i>
            {{ item.text }}
          </v-btn>
        </template>
        <v-list v-if="item.items && item.items.length > 0">
          <v-list-item
            v-for="(elem, index) in item.items"
            v-bind:key="index"
            @click="changeComponent(elem.name)"
          >
            <v-list-item-title>{{ elem.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AsyncComputed from "vue-async-computed";
import { apiCalls } from "@/mixins/apiCalls.js";
import Vue from "vue";

Vue.use(AsyncComputed);

export default {
  mixins: [apiCalls],
  computed: {
    ...mapState(["root"]),
    items: function () {
      let items = [
        {
          text: this.$t("top-menu.race.configuration"),
          icon: "far fa-cogs",
          name: null,
          items: [
            {
              text: this.$t("top-menu.race.race-classes-setup"),
              href: this.$router.resolve({ name: 'RaceClassesSetup' }).href,
              name: 'RaceClassesSetup'
            },
            {
              text: this.$t("top-menu.race.race-scoring-parameters"),
              href: this.$router.resolve({ name: 'RaceScoringParameters' }).href,
              name: 'RaceScoringParameters'
            },
            {
              text: this.$t("top-menu.race.race-participants-setup"),
              href: this.$router.resolve({ name: 'RaceParticipantsSetup' }).href,
              name: 'RaceParticipantsSetup'
            }
          ]
        },
        {
          text: this.$t("top-menu.race.results-editor"),
          icon: "far fa-pencil",
          name: "raceEdit"
        }
      ];
      if( this.isImported != null ) {
        return items;
      } else if (this.isImported == null) {
        if (this.mode == 5) {
          items.push({
            text: this.$t("top-menu.race.section-editor"),
            icon: "far fa-pencil",
            name: null
          });
        }
        if (this.mode == 4) {
          items.push({
            text: this.$t("top-menu.race.test-editor"),
            icon: "far fa-pencil",
            name: null
          });
        }
        if (this.mode == 8) {
          items.push({
            text: this.$t("top-menu.race.section-editor"),
            icon: "far fa-pencil",
            name: "EnduroSectionEditor"
          });
        }
        if (this.mode == 10) {
          items.push({
            text: this.$t("top-menu.race.section-editor"),
            icon: "far fa-pencil",
            name: "SectionEditor"
          });
        }
        items.push({
          text: this.$t("top-menu.race.phone-monitor"),
          icon: "far fa-chart-line",
          name: "PhoneMonitor"
        });
        items.push({
          text: this.$t("top-menu.race.duplicate-race"),
          icon: "far fa-copy",
          name: null
        });
      }
      this.$emit("loadTopMenuResponsive", items);
      return items;
    }
  },
  data() {
    return {
      isImported: null,
      mode: null,
    };
  },
  asyncComputed: {
    isImported: async function () {
      let data = {};

      data.param = "isImported";
      data.raceId = this.$route.params.id;

      const response = await this.postApi(
        "/api/v1/promoter/race/getRaceDetail",
        data
      );

      return response.message[0].isImported;
    },
    mode: async function () {
      var userDetails = await this.api(
        "get",
        "/api/v1/promoter/race/getUser"
      );

      if (userDetails.success == 1) {
        var isPromoter = userDetails.message[0].areaId == 2 ? true : false;

        let data = {};
        let response = [];

        if (isPromoter) {
          data.raceId = this.$route.params.id;
          data.force = true;

          response = await this.postApi("/api/v1/promoter/race", data);
        } else {
          data.raceId = this.$route.params.id;

          response = await this.postApi("/api/v1/promoter/race", data);
        }
        if (response.success == 1) {
          return response.message.mode;
        } else return null;
      } else return null;
    },
  },
  methods: {
    changePage(page) {
      var path = `/dashBoard/raceDetails/${this.$route.params.id}`;

      if (page == "dashBoard") path = `/dashBoard`;
      else if (page == "results-editor")
        path = `/dashBoard/raceDetails/${this.$route.params.id}/race-editor`;
      else if (page == "enduro-section-editor")
        path = `/enduroSectionEditor/raceId/${this.$route.params.id}`;
      else if (page == "section-editor")
        path = `/dashBoard/raceDetails/${this.$route.params.id}/section-editor`;
      else if (page == "phone-monitor")
        path = `/dashBoard/raceDetails/${this.$route.params.id}/phoneMonitor`;

      if (this.$route.path !== path)
        this.$router.push({
          path: path,
        });
    },
    changeComponent(component) {
      this.$router.push({ name: component, params: this.$route.params });
    }
  },
  created() {}
};
</script>

<style>
.styleMenuv {
  display: inline;
}
.legacy-dashboard {
  text-align: right !important;
  text-align: -moz-right !important;
  text-decoration: underline !important;
  color: #0e152d !important;
  margin-right: 10px;
}
</style>
